export default {
  relatorio: {
    values: null,
    options: [],
    required: true,
    state: null
  },
  dataInicio: {
    value: null,
    required: true,
    state: null
  },
  dataFim: {
    value: null,
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/reports/logs-form.js